import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProcessSection from './components/ProcessSection';
import FulfillmentSection from './components/FulfillmentSection';
import DangerousGoodsSection from './components/DangerousGoodsSection';
import NetworkSection from './components/NetworkSection';
import ReturnProcessSection from './components/ReturnProcessSection';
import ApiDocsSection from './components/ApiDocsSection';
import Footer from './components/Footer';
import AccountSetupPage from './pages/AccountSetupPage';
import NotFoundPage from './pages/NotFoundPage';

// Landing Page Component
const LandingPage = () => {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <ProcessSection />
        <FulfillmentSection />
        <NetworkSection />
        <DangerousGoodsSection />
        <ReturnProcessSection />
        <ApiDocsSection />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="app-container" data-testid="app-container">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/account-setup" element={<AccountSetupPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
